import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

import { RADIUS } from 'src/theme/ui-tokens';

import { usePublicTrialHref } from 'src/sections/common/hooks/model/use-public-trial-href';

import { BLOG_CTA } from '../constants/blog-copy';
import { CM, SECTION_PX, PUBLIC_TEXT, PUBLIC_CTA_SX, PUBLIC_MAX_WIDTH } from '../constants/blog-layout';

// ----------------------------------------------------------------------

const OUTLINE_ON_DARK_SX = {
  ...PUBLIC_CTA_SX,
  color: '#fff',
  border: '1px solid rgba(255,255,255,0.32)',
  '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' },
} as const;

/**
 * 블로그 목록·글 상세 맨 아래 띠 — 랜딩·MCP 소개의 체험 띠와 같은 꼴(짙은 판 · 제목 · 설명 · 단추).
 * 단추 셋: 「무료로 시작하기」(공개 지면 공통 규칙 — 로그인했으면 서비스, 아니면 로그인 화면) ·
 * 「실시간 상담하기」(채널톡) · 「데모 세션 요청하기」(예약 창) — 뒤의 둘은 새 탭이다.
 */
export function BlogCTA() {
  const trialHref = usePublicTrialHref();

  return (
    <Box component="section" sx={{ px: SECTION_PX, py: { xs: 5, md: 6 } }}>
      <Box sx={{ maxWidth: PUBLIC_MAX_WIDTH, mx: 'auto', borderRadius: RADIUS.lg, bgcolor: CM.textDark, px: { xs: 3, md: 6 }, py: { xs: 5, md: 6 }, textAlign: 'center' }}>
        <Typography component="h2" sx={{ ...PUBLIC_TEXT.title, color: '#fff', mb: 2 }}>
          {BLOG_CTA.title}
        </Typography>
        <Typography sx={{ ...PUBLIC_TEXT.lead, color: 'rgba(255,255,255,0.8)', maxWidth: 640, mx: 'auto', mb: 3 }}>
          {BLOG_CTA.lead}
        </Typography>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center">
          <Button component={RouterLink} href={trialHref} sx={{ ...PUBLIC_CTA_SX, color: '#fff', bgcolor: CM.primary, '&:hover': { bgcolor: CM.primaryDark } }}>
            {BLOG_CTA.trial}
          </Button>
          <Button component="a" href={BLOG_CTA.consultUrl} target="_blank" rel="noopener noreferrer" sx={OUTLINE_ON_DARK_SX}>
            {BLOG_CTA.consult}
          </Button>
          <Button component="a" href={BLOG_CTA.demoUrl} target="_blank" rel="noopener noreferrer" sx={OUTLINE_ON_DARK_SX}>
            {BLOG_CTA.demo}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
